export default __webpack_public_path__ + "static/media/857.74a69319.png";